import { useResizeObserver } from '@infotech-soe/erp-ui-kit';
import { useRef, useState } from 'react';

export const useTextOverflowed = () => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  const onResize = () => {
    if (textRef.current)
      setIsOverflowed(
        textRef.current.getBoundingClientRect().right > window.innerWidth ||
          textRef.current.offsetWidth < textRef.current.scrollWidth
      );
  };

  useResizeObserver(textRef, onResize);

  return { isOverflowed, textRef };
};
